import React from "react";

// The one in-page loading indicator - same brand ring as the global
// overlay (loader.js), sized for a panel, card or inline row. Use this
// instead of ad-hoc "<p>Loading...</p>" / ProgressSpinner so every
// loading state in the app looks the same.
//   size:   "sm" (inline, next to text) | "md" (panel, default) | "lg" (page)
//   inline: render as a single row instead of a centered block
export const Spinner = ({ size = "md" }) => (
  <span className={`ex-spinner ex-spinner-${size}`} aria-hidden="true" />
);

const LoadingState = ({ label = "Loading", size = "md", inline = false, className = "" }) => (
  <div
    className={`ex-loading-state${inline ? " is-inline" : ""} ex-loading-state-${size} ${className}`.trim()}
    role="status"
    aria-live="polite"
  >
    <Spinner size={inline ? "sm" : size} />
    {label && <span className="ex-loading-state-label">{label}</span>}
  </div>
);

export default LoadingState;
